import { getPlanIdentity, getPlanRank } from '../lib/plan-identity.js';

export function computePlanButtonState({
  planKey,
  billingCycle,
  pricingPlans,
  pricingPlansData,
  currentSubscription,
  isSubscriptionLoading = false,
  isPricingDataLoading = false,
  isLoggedIn = false,
  texts = {
    currentPlan: 'Current Plan',
    loading: 'Loading...',
    upgrade: 'Upgrade',
    getStarted: 'Get Started',
  },
}) {


  if (!pricingPlans || !pricingPlans[planKey]) {
    return {
      text: texts.upgrade,
      disabled: true,
      action: 'none',
    };
  }

  if (isSubscriptionLoading || isPricingDataLoading) {
    return {
      text: texts.loading,
      disabled: true,
      action: 'loading',
      planId: null,
    };
  }

  const planName = pricingPlans[planKey].name;
  const cycleLabel = billingCycle === 'monthly' ? 'Monthly' : 'Yearly';
  const fullPlanName = `${planName} ${cycleLabel}`;

  const currentPlanTier = currentSubscription?.plan ? getPlanRank(currentSubscription.plan) : null;
  const currentPlanName = currentSubscription?.plan?.name ?? null;
  const isFreeUser =
    !currentSubscription || currentPlanTier === null || currentPlanTier === 0;

  // Free plan CTA 处理
  if (planKey === 'free') {
    // 已登录且是 Free 用户 → 禁用按钮，显示为当前计划
    if (isLoggedIn && isFreeUser) {
      return {
        text: texts.currentPlan, // ✅ Use translated "Current Plan" (was Get Started + disabled)
        disabled: true,
        action: 'current',
        planId: null,
      };
    }
    // 未登录用户 → 允许点击，显示登录/注册弹窗
    if (!isLoggedIn) {
      return {
        text: pricingPlans['free'].ctaText || texts.getStarted,
        disabled: false,
        action: 'free_cta',
        planId: null,
      };
    }
    // 已登录的付费用户 → 禁用（不允许降级）
    return {
      text: pricingPlans['free'].ctaText || texts.getStarted,
      disabled: true,
      action: 'downgrade_blocked',
      planId: null,
    };
  }

  const dbPlan = pricingPlansData
    ? Object.values(pricingPlansData).find(plan => plan.name === fullPlanName)
    : null;

  if (!dbPlan) {
    return {
      text: texts.loading,
      disabled: true,
      action: 'loading',
      planId: null,
    };
  }

  // Treat null subscription or tier 0 as Free user
  if (isFreeUser) {
    return {
      text: pricingPlans[planKey].ctaText || texts.upgrade,
      disabled: false,
      action: 'new_subscription',
      planId: dbPlan.id,
    };
  }

  const targetPlanTier = getPlanRank(dbPlan);
  if (currentPlanName === fullPlanName) {
    return {
      text: texts.currentPlan,
      disabled: true,
      action: 'current',
      planId: dbPlan.id,
    };
  }

  if (targetPlanTier < currentPlanTier) {
    return {
      text: pricingPlans[planKey].ctaText || texts.upgrade,
      disabled: true,
      action: 'downgrade_blocked',
      planId: dbPlan.id,
    };
  }

  if (targetPlanTier > currentPlanTier) {
    return {
      text: pricingPlans[planKey].ctaText || texts.upgrade,
      disabled: false,
      action: 'immediate_upgrade',
      planId: dbPlan.id,
    };
  }

  if (getPlanIdentity(dbPlan) === getPlanIdentity(currentSubscription?.plan)) {
    const currentCycle = currentSubscription?.plan?.billingCycle;
    if (currentCycle === 'monthly' && billingCycle === 'yearly') {
      return {
        text: pricingPlans[planKey].ctaText || texts.upgrade,
        disabled: false,
        action: 'immediate_upgrade',
        planId: dbPlan.id,
      };
    }

    return {
      text: currentCycle === 'yearly' && billingCycle === 'monthly'
        ? (texts.upgrade || 'Upgrade') : texts.currentPlan,
      disabled: true,
      action: currentCycle === billingCycle ? 'current' : 'downgrade_blocked',
      planId: dbPlan.id,
    };
  }

  return {
    text: pricingPlans[planKey].ctaText || texts.upgrade,
    disabled: true,
    action: 'none',
    planId: dbPlan.id,
  };
}
